@if (shouldShowError) {
  <div class="error-text">
    {{ displayMessage }}
  </div>
}
